module.exports = DS.Transform.extend({
    serialize: function(date) {
        return date ? date.format('YYYY-MM-DD') : null
    },

    deserialize: function(s) {
        return s ? moment.utc(s).startOf('day') : null
    }
})
